import * as React from 'react';
const SvgMic = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='M10 11.584a2 2 0 0 1-1.478-.605A2 2 0 0 1 7.917 9.5v-5q0-.873.605-1.478A2 2 0 0 1 10 2.417q.873 0 1.478.605t.605 1.478v5q0 .873-.605 1.479a2 2 0 0 1-1.478.605m-.542 4.666v-1.705a4.86 4.86 0 0 1-3.043-1.435 4.9 4.9 0 0 1-1.452-3.047.46.46 0 0 1 .116-.397q.15-.165.377-.166.227 0 .385.163a.7.7 0 0 1 .198.387q.205 1.51 1.338 2.48 1.13.97 2.614.97 1.503 0 2.633-.98a3.87 3.87 0 0 0 1.337-2.47.73.73 0 0 1 .193-.387.5.5 0 0 1 .383-.163q.23 0 .381.166a.46.46 0 0 1 .119.397 4.88 4.88 0 0 1-1.452 3.043 4.9 4.9 0 0 1-3.043 1.44v1.704a.526.526 0 0 1-.538.542.53.53 0 0 1-.387-.156.52.52 0 0 1-.159-.386'
            />
        </g>
    </svg>
);
export default SvgMic;
